import { CheckCircle2, FileText, Loader2, Scale } from "lucide-react"
import { useTranslation } from "react-i18next"

import { KpiCard } from "@/components/kpi-card"
import { formatNumber } from "@/lib/format"
import type { Contract } from "@/types/domain"

interface ContractsKpiStripProps {
  contracts: Contract[]
}

export function ContractsKpiStrip({ contracts }: ContractsKpiStripProps) {
  const { t } = useTranslation(["contracts", "common"])

  const total = contracts.length
  const inProgress = contracts.filter(
    (c) => c.status === "IN_PROGRESS" || c.status === "OPEN",
  ).length
  const delivered = contracts.filter((c) => c.status === "DELIVERED").length
  const totalVolume = contracts.reduce((sum, c) => sum + (c.quantity ?? 0), 0)

  const mt = t("units.mt", { ns: "common" })

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard
        label={t("kpis.total")}
        value={formatNumber(total)}
        icon={FileText}
        tone="info"
      />
      <KpiCard
        label={t("kpis.inProgress")}
        value={formatNumber(inProgress)}
        icon={Loader2}
        tone="warning"
      />
      <KpiCard
        label={t("kpis.delivered")}
        value={formatNumber(delivered)}
        icon={CheckCircle2}
        tone="success"
      />
      <KpiCard
        label={t("kpis.totalVolume")}
        value={`${formatNumber(totalVolume)} ${mt}`}
        icon={Scale}
        tone="muted"
      />
    </div>
  )
}
